import { AbstractCommand } from 'src/models/command';

class CreateNewAppointmentFromTimestampAndDuration extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_CreateNewAppointmentFromTimestampAndDuration';
	readonly processId = 'random';

	public constructor() {
		super();
		this.parameters = {
			allDay: false,
			duration: 60,
		};
	}
}

export { CreateNewAppointmentFromTimestampAndDuration };
